<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content overflowShadow>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content__code-section">
        <div class="code-section__header">
          {{ '+SRC_COMMISSIONINGV2.CODE_DIALOG_ENTER_CODE_MANUALY' | translate }}
        </div>
        <div class="code-section__wrapper">
          <form
            [formGroup]="formGroup"
            class="flex flex-col gap-[16px]"
            [ngClass]="{
              'form-disabled': summaryView && !isSafari,
              'form-disabled-safari': summaryView && isSafari
            }"
          >
            <span class="flex flex-col">
              <span mat-input-top-label>{{
                '+SRC_COMMISSIONINGV2.MANUAL_INPUT_EUID' | translate
              }}</span>
              <mat-form-field mat-input-height-large-label>
                <mat-label>{{ '+SRC_COMMISSIONINGV2.MANUAL_INPUT_EUID' | translate }}</mat-label>
                <input
                  gtm="onTextField"
                  gtmId="eu-id"
                  gtmAction="Eu id"
                  gtmCategory="Commissioning"
                  [gtmOn]="['change', 'focus', 'blur']"
                  data-at-add-device-euid-input
                  matInput
                  [formControl]="formGroup.controls.id"
                  mask="AA-AA-AA-AA-AA-AA-AA-AA"
                  data-at-euid-edit
                />
                <mat-error
                  data-at-add-device-euid-input-validation-error
                  *ngIf="formGroup.controls.id.hasError('required')"
                >
                  {{ '+SRC_COMMISSIONINGV2.EUID_REQUIRED_ERROR' | translate }}
                </mat-error>
                <mat-error
                  data-at-add-device-euid-input-validation-error
                  *ngIf="formGroup.controls.id.hasError('length')"
                >
                  {{ '+SRC_COMMISSIONINGV2.EUID_LENGTH_ERROR' | translate }}
                </mat-error>
                <mat-error *ngIf="formGroup.controls.id.hasError('pattern')">
                  {{ '+SRC_COMMISSIONINGV2.EUID_PATTERN_ERROR' | translate }}
                </mat-error>
              </mat-form-field>
            </span>
            <span class="flex flex-col">
              <span mat-input-top-label>{{
                '+SRC_COMMISSIONINGV2.MANUAL_INPUT_IC' | translate
              }}</span>
              <mat-form-field mat-input-height-large-label>
                <mat-label>{{ '+SRC_COMMISSIONINGV2.MANUAL_INPUT_IC' | translate }}</mat-label>
                <input
                  gtm="onTextField"
                  gtmId="ic"
                  gtmAction="Ic"
                  gtmCategory="Commissioning"
                  [gtmOn]="['change', 'focus', 'blur']"
                  data-at-add-device-ic-input
                  matInput
                  [formControl]="formGroup.controls.ic"
                  mask="AAAA AAAA AAAA AAAA AAAA AAAA AAAA AAAA AAAA"
                  data-at-ic-edit
                />
                <mat-error
                  data-at-add-device-euid-input-validation-error
                  *ngIf="formGroup.controls.ic.hasError('required')"
                >
                  {{ '+SRC_COMMISSIONINGV2.IC_REQUIRED_ERROR' | translate }}
                </mat-error>
                <mat-error
                  data-at-add-device-ic-input-validation-error
                  *ngIf="formGroup.controls.ic.hasError('length')"
                >
                  {{ '+SRC_COMMISSIONINGV2.IC_LENGTH_ERROR' | translate }}
                </mat-error>
                <mat-error *ngIf="formGroup.controls.ic.hasError('pattern')">
                  {{ '+SRC_COMMISSIONINGV2.IC_PATTERN_ERROR' | translate }}
                </mat-error>
              </mat-form-field>
            </span>
          </form>
          <div
            class="qr-code__wrapper"
            *ngIf="(codeScannerService.isCodeScannerAvailable$ | async) && !summaryView"
          >
            <button
              class="qr-code__btn"
              data-at-code-modal-back-btn
              gtm="onPreviousStep"
              gtmAction="Previous step"
              gtmCategory="addRoomModal"
              mat-stroked-button
              color="primary"
              (click)="openQrScanner()"
            >
              {{ '+SRC_COMMISSIONINGV2.SCAN_QR_CODE' | translate }}
            </button>
          </div>

          <ng-container *ngIf="summaryView && !!euidValidationResult">
            <app-banner *ngIf="euidValidationResult === ValidateEuidResult.Success" type="success">
              {{ '+SRC_COMMISSIONINGV2.MESSAGE_VERIFICATION_SUCCESS' | translate }}
            </app-banner>

            <app-banner
              *ngIf="euidValidationResult === ValidateEuidResult.ErrorAlreadyAdded"
              type="error"
            >
              {{ '+SRC_COMMISSIONINGV2.MESSAGE_VERIFICATION_ALREADY_ADDED' | translate }}
            </app-banner>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      data-at-code-modal-back-btn
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="codeModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="Next step"
      gtmCategory="codeModal"
      data-at-code-modal-next-btn
      mat-raised-button
      color="primary"
      [disabled]="
        (!formGroup.valid && !summaryView) ||
        euidValidationResult === ValidateEuidResult.ErrorAlreadyAdded
      "
      (click)="navigateForward()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
